var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              [
                _c("h3", { staticClass: "pb-2" }, [
                  _vm._v(_vm._s(_vm.$t("My Pipeline Sorting Order"))),
                ]),
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: { draggable: ".draggable-stage" },
                      on: {
                        start: function ($event) {
                          _vm.drag = true
                        },
                        end: function ($event) {
                          _vm.drag = false
                        },
                      },
                      model: {
                        value: _vm.pipelineList,
                        callback: function ($$v) {
                          _vm.pipelineList = $$v
                        },
                        expression: "pipelineList",
                      },
                    },
                    "draggable",
                    _vm.dragOptions,
                    false
                  ),
                  [
                    _c(
                      "transition-group",
                      {
                        attrs: {
                          type: "transition",
                          name: !_vm.drag ? "flip-list" : null,
                        },
                      },
                      _vm._l(_vm.pipelineList, function (pipeline, k) {
                        return _c(
                          "b-card",
                          {
                            key: k,
                            staticClass: "pipeline mb-1 cursor-pointer",
                            class: "draggable-stage",
                          },
                          [
                            _c("div", [
                              _vm._v(
                                " #" +
                                  _vm._s(pipeline.id) +
                                  " " +
                                  _vm._s(pipeline.name) +
                                  " "
                              ),
                              false
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        padding: "0 4px",
                                      },
                                    },
                                    [_vm._v(_vm._s(pipeline.order_nr))]
                                  )
                                : _vm._e(),
                              false
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        padding: "0 4px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "#" + _vm._s(pipeline.user_order_nr)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("el-button", { on: { click: _vm.savePipelineOrder } }, [
                  _vm._v(_vm._s(_vm.$t("Save"))),
                ]),
              ],
              1
            ),
            _c("b-col"),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }